import { ITranslationOptions } from '../../../../models/translationOptions'
import { TRANSLATION_KEYS, TRANSLATION_KEYS_RETAIL } from '../translations'

export const getShowroomsFieldLabelTranslation = ({ isRetail }: ITranslationOptions) => {
  if (isRetail) {
    return TRANSLATION_KEYS_RETAIL.fieldLabel
  }

  return TRANSLATION_KEYS.fieldLabel
}
